// Golf 8: web app texts for the daily check-in and the family circle. Calm, adult; never an alarm.
export const appCareEn = {
    nav: 'Check-in and circle',
    notForRelative: "This page isn't available to watchers.",
    account: 'Account',
    viaBoard: '(said yes on the board)',
    viaApp: '(said yes in the app)',
    subjectLabel: 'Who taps every day?',
    removed: '{label} has been removed from the circle.',
    left: 'You have left the circle.',
    comingSoon: 'The daily check-in and the family circle are coming soon. The board, the calendar and the reminders already work.',
    wizardSeniorLine: 'Will family follow along later? You can turn that on in Settings, Check-in and circle.',
    setupSaved: 'The check-in is ready.',
    circleOn: 'Let family follow along',
    personRights: 'Rights of {label}',
    managerSeesAll: 'Manages the board and sees everything.',
    noReachSave: 'You can turn it on once someone can get a notice.',
    consentLaterWizard: 'The check-in only starts once {name} says yes on the board.',
    title: 'Check-in and circle',
    settingsBody: "One big 'All good' button on the board, and family who follow from a distance.",
    widgetTitle: 'Daily check-in',
    setupTitle: 'How you stay in touch',
    setupIntro: "Every day {name} taps 'All good' once. If that doesn't happen, the family gets a calm heads-up.",
    whoUsesBoard: 'Who uses the board?',
    boardSelf: 'Myself',
    boardOther: 'Someone else',
    otherName: "What is this person's name?",
    otherNamePlaceholder: 'For example Mum',
    ownerHidden: "You're not shown on the board.",
    capacityQ: 'Can {name} decide this for themselves?',
    capacityYes: 'Yes',
    capacityNoButton: 'No',
    capacityNo: "Then we can't turn on the check-in yet. {name} needs to be able to say yes. The board and the calendar work as usual.",
    checkInToggle: 'Daily check-in',
    deadline: 'No later than',
    days: 'On these days',
    dayNames: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    grace: 'Notify after',
    graceMin: '{n} minutes',
    whoFollows: 'Who follows along?',
    whoFollowsHint: 'Everyone gets an e-mail. Then {name} says on the board whether that is okay.',
    inviteEmail: 'E-mail address',
    inviteLabel: 'What does {name} call you?',
    inviteLabelOther: 'What does {name} call this person?',
    addPerson: 'Someone else',
    rightAlerts: "Heads-up if 'All good' doesn't come",
    rightAgenda: 'See the calendar (without private appointments)',
    invite: 'Invite',
    invited: 'Invitation sent to {email}',
    later: 'Later',
    disclaimerTitle: 'Not an alarm service',
    disclaimerBody: "The check-in is a calm heads-up, not an alarm. It doesn't detect falls and doesn't call for help. No message doesn't always mean all is well. In an emergency, call 112.",
    disclaimerCheck: 'I understand this is not an alarm service.',
    selfConsentNow: 'Because you use the board yourself, we ask for your yes here.',
    otherConsentLater: 'The first time, the board asks {name} whether this is okay. Until then no heads-up is sent.',
    finish: 'Done',
    save: 'Save',
    saved: 'Saved',
    cancel: 'Cancel',
    enable: 'Turn on',
    disable: 'Turn off',
    reachTitle: 'Who gets a heads-up?',
    reachOk: '{n} of {m} get a heads-up right now.',
    reachNone: 'Nobody gets a heads-up right now.',
    reachNeedsInstall: '{label} first needs to add AMUMIN to the home screen.',
    reachNoPush: "{label} hasn't turned on notifications yet.",
    reachFailed: "The last heads-up to {label} didn't arrive.",
    reachEnableFirst: 'Turn on notifications on your phone first. Then you can turn on the check-in.',
    noReachInvited: 'Nobody can get a heads-up yet: {names} still has to accept the invitation. Then you can turn on the check-in.',
    noReachYourYes: 'Nobody can get a heads-up yet: {names} is waiting for your yes (at the top of Today). Then you can turn on the check-in.',
    noReachTheirYes: 'Nobody can get a heads-up yet: {names} is waiting for the yes of {name} on the board.',
    noReachPush: 'Nobody can get a heads-up yet: {names} first has to turn on notifications. Then you can turn on the check-in.',
    noReachSelf: 'Nobody can get a heads-up yet. Invite someone to follow along; they accept the invitation and turn on notifications.',
    pendingOnTitle: 'The check-in is still off',
    pendingOnReady: 'Someone can now get a heads-up ({n} of {m}). You can turn on the check-in.',
    pendingOnButton: 'Turn on the check-in',
    pendingOnDone: 'The check-in is on.',
    pushEnable: "Turn on notifications on this phone for {name}'s home",
    pushOpen: 'Set up notifications',
    iosInstall: "On an iPhone: tap Share, then 'Add to Home Screen', and open AMUMIN from there.",
    waitConsent: "Waiting for {name}'s yes on the board.",
    declined: '{name} would rather not. You can ask again after {date}.',
    askAgain: 'Ask again on the board',
    activeSince: 'On since {date}',
    stoppedGone: '{name} is no longer in this household. The check-in is off.',
    stoppedBySelf: '{name} turned off the check-in. You can ask again.',
    orphanTitle: 'You are no longer part of a home',
    orphanBody: 'You no longer follow anyone and you are not a member of a household. Your account stays until you delete it yourself.',
    orphanAccount: 'Account',
    orphanLogout: 'Log out',
    stateDone: "{name} tapped 'All good' at {time}.",
    stateWaiting: 'Not yet. By {time}.',
    stateDue: 'Not yet. {name} can still tap.',
    stateMissing: "No 'All good' from {name} yet today.",
    stateMissingEarlier: "Yesterday ({date}) no 'All good' came from {name}.",
    stateBoardOffline: 'The board has been offline since {time}, so {name} may not be able to tap.',
    stateNoBoard: 'No board is paired.',
    stateResolved: 'All fine after all: {name} tapped at {time}.',
    stateResolvedOffline: 'All fine after all: {name} tapped at {time} (the board was offline).',
    stateResolvedManual: "{label}: it's fine ({time}).",
    stateNotChecked: "We couldn't check today (AMUMIN had a problem). Please check in on them yourself.",
    stateDegraded: "We're not checking right now (a problem on our side).",
    statePaused: 'Paused until {date} (set by {label}).',
    stateOff: 'The check-in is off.',
    stateNotToday: 'No check-in today.',
    stateConsentNeeded: "Waiting for {name}'s yes on the board.",
    stateDeclined: '{name} would rather not.',
    silenceNote: "No message doesn't always mean all is well.",
    emergencyNote: 'Not an alarm service. In an emergency: 112.',
    ack: "I'll call",
    acked: '{label} is calling ({time})',
    ackStale: '{label} has been calling since {time}, not confirmed yet.',
    resolve: "It's fine",
    tzNote: "({name}'s time)",
    history: 'Last {n} days',
    historyKinds: {
        done: 'All good',
        late: 'Tapped later',
        missing: 'No tap',
        paused: 'Paused',
        not_checked: 'Not checked',
        off: 'No check-in',
    },
    pauses: 'Pauses',
    pauseAdd: 'Add a pause',
    pauseFrom: 'From',
    pauseTo: 'Until',
    pauseMax: 'At most {n} days. Away longer? Then turn the check-in off.',
    inviteInUse: 'This address already has an invitation as a housemate. Withdraw that one first.',
    pauseLimit: 'Someone who follows along can set at most {n} days of pause in total, and no more than {n} days ahead.',
    someone: 'someone',
    pauseHint: "For example on holiday or staying over. We don't store a reason.",
    pauseLine: '{from} until {to} (set by {label})',
    pauseStop: 'Stop pause',
    pauseNone: 'No pause planned.',
    offlineTitle: 'What if the board is offline?',
    offlineHelp: 'If the board has no connection, a tap is sent later. {name} can also use the app on the phone.',
    outageTitle: 'What if AMUMIN has a problem?',
    outageHelp: "If AMUMIN has a problem, you'll see 'Not checked today' here. No message is no proof that all is well.",
    circleTitle: 'Circle',
    circleEmpty: 'Nobody follows along yet.',
    circleStatusInvited: 'Invited',
    circleStatusPending: "Waiting for {name}'s yes",
    circleStatusActive: 'Active',
    circleStatusDeclined: 'Rather not',
    roleRelative: 'Watcher',
    roleManager: 'Manager',
    remove: 'Remove from the circle',
    removeConfirm: 'Remove {label} from the circle? {label} will immediately see nothing anymore.',
    removePauseNote: '{label} set a pause until {date}. That pause stops when you remove {label}.',
    leave: 'Leave the circle',
    leaveConfirm: "Leave the circle? You will no longer see anything of {name}'s home.",
    resend: 'Send again',
    rightsNeedYes: 'More rights? Then the board first asks {name} for a yes.',
    newWatcher: '{label} now follows along: {rights}.',
    inviteSomeone: 'Invite someone',
    seniorNoCircle: 'There is nobody yet who can get a heads-up.',
    switchToCare: "Becomes 'At home with family following along'",
    selfButton: 'All good',
    selfConsentIntro: 'Read this calmly. You decide.',
    selfWithdraw: 'Stop the check-in',
    approveTitle: '{label} would like to follow along',
    approveYes: "Yes, that's fine",
    approveNo: 'Rather not',
    myCircleTitle: 'My circle',
    myRights: "What you see in {name}'s home",
    myRightsNone: 'You see nothing yet: {name} first says yes on the board.',
    pushCheckIn: 'Daily check-in',
    pushCheckInQuiet: 'Also during quiet hours (otherwise the heads-up comes when they end)',
    inviteTitle: 'Invitation to follow along',
    inviteBody: '{inviter} invites you to follow along at {household}, as "{label}".',
    inviteRights: 'You may:',
    inviteAcceptExisting: 'Accept',
    inviteLoginFirst: 'First log in with {email}, then open the link again.',
    inviteAcceptNew: 'Create account and accept',
    invitePassword: 'Choose a password',
    inviteWrongEmail: 'This invitation is for a different e-mail address.',
    inviteInvalid: 'This invitation is invalid or has expired.',
    inviteAccepted: "Done. The board first asks whether this is okay. Then you'll see it here.",
    inviteToApp: 'Go to the app',
    notEmergencyShort: 'This is not an alarm service.',
    errorGeneric: "That didn't work. Please try again.",
};
//# sourceMappingURL=careApp.en.js.map